
























import Vue from "vue";
import { mapState, mapGetters } from "vuex";
import UserList from "../components/billing/user-list.vue";
import PlanSelector from "../components/billing/plan-selector.vue";

export default Vue.extend({
  components: { UserList, PlanSelector },
  data() {
    return {
      showPlanSelector: false,
      userId: 1,
      name: "Test",
      email: "test@gmail.com",
      phone: 111 - 111 - 1111,
    };
  },
  computed: {
    ...mapState("goal", ["loading"]),
    ...mapState("session", ["billingAccountIdChangedCount", "billingAccounts"]),
    ...mapState("session", ["user"]),
  },
  mounted() {
    this.loadAccountInfo();
  },
  watch: {
    user(newValue) {
      if (newValue) {
        (this as any).$intercom.boot({
          user_id: (this as any).user.id,
          user_hash: (this as any).user.intercomUserHash,
          name: (this as any).user.name,
          email: (this as any).user.emailAddress,
          phone: (this as any).user.phoneNumber,
        });
        (this as any).$intercom.show();
      }
    },
    email(email) {
      (this as any).$intercom.update({ email });
    },
  },
  created() {},
  methods: {
    loadAccountInfo() {
      this.$store
        .dispatch("billing/getBillingAccountInfo")
        .then((response) => {})
        .finally(() => {});
    },
    handleChangePlan() {
      this.showPlanSelector = true;
    },
  },
});
